import React from 'react'
import Signupsec from '../Mainsignup/Signupsec'

const main = () => {
  return (
    <div>
        <Signupsec/>
    </div>
  )
}

export default main
